import { Component, Input } from '@angular/core';
import { IReporteContribuciones, IVivienda, IViviendaConTotales } from 'src/app/models/contribuciones/contribuciones.model';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { AlertService } from '../../_alert/alert.service';
import { goToTop } from 'src/app/shared/utils/utils';

@Component({
  selector: 'app-contribuciones-viewer',
  templateUrl: './contribuciones-viewer.component.html',
  styleUrls: ['./contribuciones-viewer.component.scss']
})
export class ContribucionesViewerComponent {
    @Input() content!: IReporteContribuciones;
    @Input() rut!: string;
    @Input() showHeader = true;

    private readonly CONDICION = {
        VIGENTE: 'VIGENTE',
        VENCIDA: 'VENCIDA',
    } as const;

    private idTransaccion!: string;
    public today = '';

    public viviendas: IVivienda[] = [];
    public viviendasConTotales: IViviendaConTotales[] = [];
    public numPropiedades?: number;
    public totalCuotasVigentes?: number;
    public totalCuotasVencidas?: number;

    public cuotasDisplayedColumns: string[] = [
        'año',
        'numCuota',
        'condicion',
        'vencimiento',
        'valorBase',
        'reajustes',
        'intereses',
        'condonacion',
        'totalAPagar',
    ];

    isPDFLoading = false;
    PDF_REPORT_NAME = 'contribuciones';

    constructor(
        private pdfGeneratorService: PdfGeneratorService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.setToday();
        this.viviendas = this.content.Reporte.viviendas;

        this.setViviendasConTotales();
        this.setNumPropiedades();

        this.totalCuotasVigentes = this.getTotalCuotas(this.CONDICION.VIGENTE);
        this.totalCuotasVencidas = this.getTotalCuotas(this.CONDICION.VENCIDA);

        this.idTransaccion = this.content.DatosBasicosSolicitud.IDTransaccion;
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    setViviendasConTotales() {
        this.viviendasConTotales = this.viviendas.map(vivienda => {
            return {
                ...vivienda,
                totalCuotasVigentes: vivienda.cuotas
                    .filter(cuota => cuota.condicion === this.CONDICION.VIGENTE)
                    .reduce((total, cuota) => total + cuota.totalPago, 0),
                totalCuotasVencidas: vivienda.cuotas
                    .filter(cuota => cuota.condicion === this.CONDICION.VENCIDA)
                    .reduce((total, cuota) => total + cuota.totalPago, 0),
            };
        });
    }

    setNumPropiedades() {
        this.numPropiedades = this.viviendas.length;
    }

    getTotalCuotas(condicion: string) {
        return this.viviendas.reduce((total, vivienda: IVivienda) => {
            const sumaCuotas = vivienda.cuotas
                .filter(cuota => cuota.condicion === condicion)
                .reduce((acum, cuota) => acum + cuota.totalPago, 0);

            return total + sumaCuotas;
        }, 0);
    }

    getPDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._getPDF(this.idTransaccion, this.PDF_REPORT_NAME).subscribe(
            response => {
                if (response.URLReporte) {
                    window.open(response.URLReporte, '_blank');
                }
                this.isPDFLoading = false;
            },
            ({error}) => {
                this.alertService.error(`Error al obtener el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

    generatePDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._generatePDF(this.idTransaccion, this.PDF_REPORT_NAME, '', '', this.rut).subscribe(
            () => {
                this.getPDF();
            },
            ({error}) => {
                this.alertService.error(`Error al generar el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

}
